import React from "react";
import { injectIntl } from 'react-intl';
import { Alert } from "react-bootstrap";
import Plague from "../../common/models/Plague";
import API from "../../common/utils/API";
import Form from '../../components/form/plagues/PlagueForm';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import LoadingButton from '../../components/form/LoadingButton';
import { Redirect } from "react-router-dom";


export class EditPlague extends React.Component {
    constructor (props) {
        super(props);
        this.state =  {
            loading: false,
            shouldRedirectToDetail: false,
            shouldRedirectToIndex: false,
            plague: new Plague(),
            errorMessage: '',
            isLoadErrorModalOpen: false,
            redirectSuccessMessage: '',
        }
    }
    async componentDidMount() {
        await Promise.all([this.fetchDetail()]);
    }

    fetchDetail = async() => {
        this.setState({
            loading: true,
        })
        try {
            const detail = await API.plagues.detail(this.props.match.params.id);
            this.setState({
                plague: detail,
                loading: false,
                isLoadErrorModalOpen: false,
            })
        } catch (error) {
            this.setState({
                isLoadErrorModalOpen: true,
                loading: false,
            });
        }
    }

    onSubmit = async (input) => {
        this.setState({loading: true});
            try {
            await API.plagues.update(
                this.props.match.params.id,
                {name: input.name},
            );

            this.setState({
                shouldRedirectToDetail: true,
                loading: false,
                redirectSuccessMessage: this.props.intl.formatMessage({
                    id: 'PLAGUES.PLAGUE_SUCCESSFULLY_UPDATED_MESSAGE',
                }),
            });
        } catch (e) {
            if (e.response && e.response.status === 422) {
                const errorMessage = Object.values(
                    e.response.data.messages,
                ).join('\n');

                this.setState({
                    loading: false,
                    errorMessage,
                });
            } else {
                this.setState({
                    loading: false,
                    errorMessage: this.props.intl.formatMessage({
                        id: 'ERROR_PAGES.UPDATING_DATA',
                    }),
                });
            }
        }
    };

    handleDeleteDetail = async() => {
        this.setState({loading: true});

        try {
            await API.plagues.delete(this.props.match.params.id);

            this.setState({
                loading: false,
                shouldRedirectToIndex: true,
                redirectSuccessMessage: this.props.intl.formatMessage({
                    id: 'PLAGUES.PLAGUE_SUCCESSFULLY_DELETED_MESSAGE',
                }),
            });
        } catch (e) {
            this.setState({
                loading: false,
                errorMessage: this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.DELETING_DATA',
                }),
            });
        }
    }
    render() {
        const initialValues =  {
            name: this.state.plague.name,
        }
        return this.state.shouldRedirectToDetail ? (
            <Redirect
                data-test='redirectToDetail'
                to={{
                    pathname: `/plagues/${this.props.match.params.id}`,
                    state: { successMessage: this.state.redirectSuccessMessage,},
                }}
            />
        ): this.state.shouldRedirectToIndex ? (
            <Redirect
                data-test='redirectToIndex'
                to={{
                    pathname: '/plagues',
                    state: {
                        successMessage: this.state.redirectSuccessMessage,
                    },
                }}
            />
        ) :
        (<>
            <Alert
                variant='danger'
                className='mb-4'
                show={!!this.state.errorMessage}
            >
                <p className='mb-0'>{this.state.errorMessage}</p>
            </Alert>

            <Form data-test='updatePlagueComponent'
                initialValues={initialValues}
                backRedirectUrl={`/plagues/${this.props.match.params.id}`}
                loading={this.state.loading}
                isEdit={true}
                handleSubmit={this.onSubmit}
                handleDeleteItem={this.handleDeleteDetail}
                backText={this.props.intl.formatMessage({
                    id: 'LIST.BACK_TO_DETAIL',
                })}
            >
            </Form>

            <Modal
                show={this.state.isLoadErrorModalOpen}
                onHide={this.toggleLoadErrorModal}
                >
                    <Modal.Header>
                        <Modal.Title>
                            {this.props.intl.formatMessage({
                                id: 'USERS.ERROR_MODAL_TITLE',
                            })}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.intl.formatMessage({
                            id: 'USERS.ERROR_MODAL_TEXT',
                        })}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant='secondary'
                            className='btn-bold btn-light-dark'
                            href={`/plagues/${this.props.match.params.id}`}
                        >
                            {this.props.intl.formatMessage({
                                id: 'GENERAL.ERROR_MODAL_BACK_BUTTON',
                            })}
                        </Button>
                        <LoadingButton
                            variant='primary'
                            className='btn-bold'
                            loading={this.state.loading}
                            onClick={this.fetchUser}
                        >
                            {this.props.intl.formatMessage({
                                id: 'GENERAL.ERROR_MODAL_RETRY_BUTTON',
                            })}
                        </LoadingButton>
                    </Modal.Footer>
            </Modal>
        </>);
    }
}

export default injectIntl(EditPlague);
